export const tokens = {
  text: {
    primary:   "#111827",   // headings, active states
    body:      "#374151",   // table body, paragraphs
    secondary: "#6B7280",   // labels, dates, captions
    muted:     "#9CA3AF",   // uppercase headers, placeholders
    subtle:    "#94A3B8",   // unchecked checkboxes, pending
    excerpt:   "#4B5563",   // italicized quotes
    disabled:  "#D1D5DB",   // disabled controls
  },
  bg: {
    surface: "#FFFFFF",
    hover:   "#F9FAFB",
    muted:   "#F3F4F6",
    border:  "#E5E7EB",
  },
  border: {
    light:     "#F3F4F6",
    default:   "#E5E7EB",
    container: "rgba(229,231,235,0.8)",
  },
  status: {
    danger:      "#DC2626",
    dangerHover: "#B91C1C",
    dangerBg:    "#FEE2E2",
    warning:     "#D97706",
    warningBg:   "#FEF3C7",
    success:     "#059669",
    successBg:   "#ECFDF5",
    info:        "#2563EB",
    infoBg:      "#DBEAFE",
  },
  brand: {
    primary:      "#0B494B",
    primaryHover: "#093B3D",
    accent:       "#1CB4BA",
    accentLight:  "#33dae0",
    accentFocus:  "rgba(28, 180, 186, 0.24)",
  },
  fontSize: {
    "2xs": "10px",    // uppercase labels, table headers
    xs:    "11px",    // sub-headers
    sm:    "11.5px",  // table body standard
    sm2:   "12.5px",  // compliance tables, trade-data detail
    base:  "12px",    // table body compact, most body text
    md:    "13px",    // stats bar compact
    lg:    "14px",    // tab labels, section titles
    xl:    "16px",    // stats bar standard
  },
  fontWeight: {
    light:    375,
    normal:   400,
    book:     425,
    medium:   475,
    semibold: 500,
    bold:     600,
    heavy:    700,
  },
  chip: {
    indigo: { bg: "#E0E7FF", text: "#4F46E5" },
    blue:   { bg: "#DBEAFE", text: "#1D4ED8" },
    green:  { bg: "#D1FAE5", text: "#047857" },
    amber:  { bg: "#FEF3C7", text: "#92400E" },
    red:    { bg: "#FEE2E2", text: "#DC2626" },
    gray:   { bg: "#F3F4F6", text: "#374151" },
  },
  radius: {
    sm: "6px",
    md: "8px",
    lg: "10px",
    full: "9999px",
  },
  scrollbar: {
    track:      "#F0F0F0",
    thumb:      "#C4C4C4",
    thumbHover: "#A0A0A0",
  },
  shadow: {
    sm:   "0 1px 2px 0 rgba(0,0,0,0.05)",
    card: "0 1px 2px rgba(0,0,0,0.05)",
  },
} as const;

export const labelStyle = {
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  fontSize: tokens.fontSize["2xs"],
  fontWeight: tokens.fontWeight.normal,
  color: tokens.text.muted,
  lineHeight: "14px",
} as const;

export const FLAG_EMOJI_SIZE = "20px";
